export default __webpack_public_path__ + "static/media/image.0ad8bd22.png";